import { useEffect, useRef, useState } from "react";

import "./style.css";

import EmojiPickerBackgrounds from "./EmojiPickerBackgrounds";
import AddToYourPost from "./AddToYourPost";
import ImagePreview from "./ImagePreview";
import FeelingActivitySelector from "./FeelingActivitySelector";
import FriendsListModal from "./FriendsListModal";
import LocationPickerModal from "./LocationPickerModal";
import PostError from "./PostError";

import PulseLoader from "react-spinners/PulseLoader";

import useClickOutside from "../../helpers/clickOutside";
import dataURItoBlob from "../../helpers/dataURItoBlob";

import { uploadImages } from "../../functions/uploadImages";
import { createPost } from "../../functions/post";

import { useNavigate } from "react-router-dom";
import { Send } from "../../svg";








export default function CreatePostPopup({ user, setVisible, posts, dispatch, getAllPosts, initialImages = [], initialVideos = [], clearInitialMedia }) {

  const navigate = useNavigate();

  const popup = useRef(null);

  
  
  // Helper functions for feeling/activity display

  const getFeelingEmoji = (feelingId) => {

    const feelings = {

      "happy": "😊", "sad": "😢", "angry": "😠", "excited": "🤩", "grateful": "🙏",

      "blessed": "🙌", "loved": "💕", "thankful": "🙏", "amazed": "😲", "proud": "😎",

      "hopeful": "✨", "confident": "💪", "peaceful": "😌", "joyful": "😄", "inspired": "💡",

      "motivated": "🚀", "energetic": "⚡", "relaxed": "😴", "focused": "🎯", "creative": "🎨",

      "adventurous": "🗺️", "curious": "🤔", "surprised": "😮", "nostalgic": "📷", "romantic": "💖"

    };

    return feelings[feelingId] || "😊";

  };



  const getFeelingLabel = (feelingId) => {

    const feelings = {

      "happy": "Happy", "sad": "Sad", "angry": "Angry", "excited": "Excited", "grateful": "Grateful",

      "blessed": "Blessed", "loved": "Loved", "thankful": "Thankful", "amazed": "Amazed", "proud": "Proud",

      "hopeful": "Hopeful", "confident": "Confident", "peaceful": "Peaceful", "joyful": "Joyful", "inspired": "Inspired",

      "motivated": "Motivated", "energetic": "Energetic", "relaxed": "Relaxed", "focused": "Focused", "creative": "Creative",

      "adventurous": "Adventurous", "curious": "Curious", "surprised": "Surprised", "nostalgic": "Nostalgic", "romantic": "Romantic"

    };

    return feelings[feelingId] || "Happy";

  };



  const getActivityEmoji = (activityId) => {

    const activities = {

      "traveling": "✈️", "working": "💼", "studying": "📚", "exercising": "🏃‍♂️", "cooking": "👨‍🍳",

      "reading": "📖", "watching": "📺", "listening": "🎧", "playing": "🎮", "shopping": "🛒",

      "cleaning": "🧹", "gardening": "🌱", "painting": "🎨", "writing": "✍️", "dancing": "💃",

      "singing": "🎤", "photography": "📸", "gaming": "🎮", "meditation": "🧘‍♂️", "yoga": "🧘‍♀️",

      "running": "🏃‍♀️", "cycling": "🚴‍♂️", "swimming": "🏊‍♂️", "hiking": "🏔️", "camping": "⛺",

      "fishing": "🎣", "golfing": "⛳", "tennis": "🎾", "basketball": "🏀", "football": "⚽",

      "volleyball": "🏐", "baseball": "⚾", "soccer": "⚽", "hockey": "🏒", "boxing": "🥊",

      "martial_arts": "🥋", "weightlifting": "🏋️‍♂️", "pilates": "🧘‍♀️", "zumba": "💃", "crossfit": "💪",

      "rock_climbing": "🧗‍♂️", "skateboarding": "🛹", "surfing": "🏄‍♂️", "skiing": "⛷️", "snowboarding": "🏂",

      "ice_skating": "⛸️", "rollerblading": "🛼", "parkour": "🤸‍♂️", "gymnastics": "🤸‍♀️", "cheerleading": "📣",

      "marching_band": "🎺", "orchestra": "🎻", "choir": "🎤", "karaoke": "🎤"

    };

    return activities[activityId] || "🎯";

  };



  const getActivityLabel = (activityId) => {

    const activities = {

      "traveling": "Traveling", "working": "Working", "studying": "Studying", "exercising": "Exercising", "cooking": "Cooking",

      "reading": "Reading", "watching": "Watching", "listening": "Listening", "playing": "Playing", "shopping": "Shopping",

      "cleaning": "Cleaning", "gardening": "Gardening", "painting": "Painting", "writing": "Writing", "dancing": "Dancing",

      "singing": "Singing", "photography": "Photography", "gaming": "Gaming", "meditation": "Meditation", "yoga": "Yoga",

      "running": "Running", "cycling": "Cycling", "swimming": "Swimming", "hiking": "Hiking", "camping": "Camping",

      "fishing": "Fishing", "golfing": "Golfing", "tennis": "Tennis", "basketball": "Basketball", "football": "Football",

      "volleyball": "Volleyball", "baseball": "Baseball", "soccer": "Soccer", "hockey": "Hockey", "boxing": "Boxing",

      "martial_arts": "Martial Arts", "weightlifting": "Weightlifting", "pilates": "Pilates", "zumba": "Zumba", "crossfit": "CrossFit",

      "rock_climbing": "Rock Climbing", "skateboarding": "Skateboarding", "surfing": "Surfing", "skiing": "Skiing", "snowboarding": "Snowboarding",

      "ice_skating": "Ice Skating", "rollerblading": "Rollerblading", "parkour": "Parkour", "gymnastics": "Gymnastics", "cheerleading": "Cheerleading",

      "marching_band": "Marching Band", "orchestra": "Orchestra", "choir": "Choir", "karaoke": "Karaoke"

    };

    return activities[activityId] || "Activity";

  };

  const [text, setText] = useState("");

  const [loading, setLoading] = useState(false);



  const [error, setError] = useState("");

  const [images, setImages] = useState([]);

  const [videos, setVideos] = useState([]);

  const [background, setBackground] = useState("");

  const [selectedFeeling, setSelectedFeeling] = useState(null);

  const [selectedActivity, setSelectedActivity] = useState(null);

  const [showFeelingActivitySelector, setShowFeelingActivitySelector] = useState(false);

  const [showFriendsListModal, setShowFriendsListModal] = useState(false);

  const [showLocationPickerModal, setShowLocationPickerModal] = useState(false);

  const [selectedFriends, setSelectedFriends] = useState([]);

  const [selectedLocation, setSelectedLocation] = useState(null);

  const [showPrev, setShowPrev] = useState(false);
  const mediaInputShouldOpen = useRef(false);

  
  
  // Determine account privacy from user (if available) or localStorage fallback

  const accountPrivacy = (user && (user.privacy || user?.profile?.privacy)) || localStorage.getItem("accountPrivacy") || "public";

  
  
  // Function to reset all form states

  const resetForm = () => {

    setText("");

    setImages([]);

    setVideos([]);

    setBackground("");

    setSelectedFeeling(null);

    setSelectedActivity(null);

    setShowFeelingActivitySelector(false);

    setShowFriendsListModal(false);

    setShowLocationPickerModal(false);

    setSelectedFriends([]);

    setSelectedLocation(null);

    setShowPrev(false);

    setError("");

  };
  // Seed with media chosen from home page, then show preview
  useEffect(() => {
    if ((initialImages.length || initialVideos.length) && !showPrev) {
      setImages(initialImages);
      setVideos(initialVideos);
      setBackground("");
      setShowPrev(true);
      if (typeof clearInitialMedia === 'function') clearInitialMedia();
    }
  }, [initialImages, initialVideos, showPrev, clearInitialMedia]);

  useClickOutside(popup, () => {
    resetForm();
    setVisible(false);
  }, [
    ".feeling_activity_selector",
    ".feeling_activity_overlay",
    ".tag_friends_modal",
    ".location_picker_modal",
  ]);



  // Handler for tag button click

  const handleTagClick = () => {

    setShowFriendsListModal(true);

  };



  // Handler for location button click

  const handleLocationClick = () => {

    setShowLocationPickerModal(true);

  };



  // Handler for friends selection

  const handleFriendsSelection = (friends) => {

    setSelectedFriends(friends);

  };



  // Handler for location selection

  const handleLocationSelection = (location) => {

    console.log("Location selected:", location);

    setSelectedLocation(location);

  };

  const postSubmit = async () => {

    if (background) {

      setLoading(true);

      console.log("Submitting post with location:", selectedLocation);

      const response = await createPost(

        null,

        background,

        text,

        null,

        user.id,

        user.token,

        selectedFeeling,

        selectedActivity,

        selectedLocation,

        selectedFriends

      );

      setLoading(false);

      if (response.status === "ok") {

        dispatch({

          type: "ADD_POST",

          payload: response.data,

        });

        resetForm();

        setVisible(false);

        navigate("/");

      } else {

        setError(response.message);

      }

    } else if (images && images.length) {

      setLoading(true);

      const postImages = images.map((img, idx) => {

        return dataURItoBlob(img, `post_image_${Date.now()}_${idx}`);

      });

      const path = `${user.username}/post Images`;

      let formData = new FormData();

      formData.append("path", path);

      postImages.forEach((image) => {

        formData.append("file", image);

      });

      const imageResponse = await uploadImages(formData, path, user.token);

      if (!Array.isArray(imageResponse)) {
        setLoading(false);
        setError(imageResponse || "Failed to upload images");
        return;
      }

      const res = await createPost(

        null,

        null,

        text,

        imageResponse,

        user.id,

        user.token,

        selectedFeeling,

        selectedActivity,

        selectedLocation,

        selectedFriends

      );

      setLoading(false);

      if (res.status === "ok") {

        dispatch({

          type: "ADD_POST",

          payload: res.data,

        });

        resetForm();

        setVisible(false);

        navigate("/");

      } else {

        setError(res.message);

      }

    } else if (videos && videos.length) {

      setLoading(true);

      const postVideos = videos.map((video, idx) => {

        return dataURItoBlob(video, `post_video_${Date.now()}_${idx}`);

      });

      const path = `${user.username}/post Videos`;

      let formData = new FormData();

      formData.append("path", path);

      postVideos.forEach((video) => {

        formData.append("file", video);

      });

      const videoResponse = await uploadImages(formData, path, user.token);

      if (!Array.isArray(videoResponse)) {
        setLoading(false);
        setError(videoResponse || "Failed to upload videos");
        return;
      }

      const res = await createPost(

        null,

        null,

        text,

        videoResponse,

        user.id,

        user.token,

        selectedFeeling,

        selectedActivity,

        selectedLocation,

        selectedFriends

      );

      setLoading(false);

      if (res.status === "ok") {

        dispatch({

          type: "ADD_POST",

          payload: res.data,

        });

        resetForm();

        setVisible(false);

        navigate("/");

      } else {

        setError(res.message);

      }

    } else if (text) {

      setLoading(true);

      const response = await createPost(

        null,

        null,

        text,

        null,

        user.id,

        user.token,

        selectedFeeling,

        selectedActivity,

        selectedLocation,

        selectedFriends

      );

      setLoading(false);

      if (response.status === "ok") {

        dispatch({

          type: "ADD_POST",

          payload: response.data,

        });

        resetForm();

        setVisible(false);

        navigate("/");

      } else {

        setError(response.message);

      }

    } else {

      setError("Please add some text, images, videos, or select a background before posting");

    }

  };

  return (

    <div className="blur">

      <div className="postBox" ref={popup}>

        {loading && (

          <div className="spinner">

            <div className="bounce1"></div>

            <div className="bounce2"></div>

            <div className="bounce3"></div>

          </div>

        )}

        {error && <PostError error={error} setError={setError} />}

        <div className="postBox_body">
        <div className="box_header">
          <div className="box_header_left">
            <div className="box_header_text">
              <h2>Create Publication</h2>
              <p>Share your thoughts with the world</p>
            </div>
          </div>

          <div
            className="small_circle"
            onClick={() => {
              resetForm();
              setVisible(false);
            }}
          >
            <i className="exit_icon"></i>
          </div>
        </div>

        <div className="box_profile">
          <img src={user.picture} alt="" className="box_profile_img" />
          <div className="box_col">
            <div className="box_profile_name">
              {user.first_name} {user.last_name}
            </div>
            <div className="box_privacy">
              <img
                src={`../../../icons/${
                  accountPrivacy === "private" ? "lock.png" : "public.png"
                }`}
                alt=""
              />
              <span>
                {accountPrivacy === "private" ? "Private" : "Public"}
              </span>
              <i className="arrowDown_icon"></i>
            </div>
          </div>
        </div>



        {!showPrev ? (

          <>

            <EmojiPickerBackgrounds

              text={text}

              user={user}

              setText={setText}

              showPrev={showPrev}

              setBackground={setBackground}

              background={background}

            />

          </>

        ) : (

          <ImagePreview

            text={text}

            user={user}

            setText={setText}

            showPrev={showPrev}

            images={images}

            videos={videos}

            setImages={setImages}

            setVideos={setVideos}

            setShowPrev={setShowPrev}

            setError={setError}

            autoOpen={mediaInputShouldOpen.current}
            onPickerOpened={() => { mediaInputShouldOpen.current = false; }}

          />

        )}

        <AddToYourPost 

          setShowPrev={setShowPrev} 

          onFeelingActivityClick={() => setShowFeelingActivitySelector(true)}

          onTagClick={handleTagClick}

          onLocationClick={handleLocationClick}

        />

        
        
        {/* Display selected feeling/activity */}

        {(selectedFeeling || selectedActivity) && (
          <div className="selected_feeling_activity">
            {selectedFeeling && (
              <div className="selected_item_display">
                <span className="selected_emoji notranslate" translate="no">
                  {getFeelingEmoji(selectedFeeling)}
                </span>
                <span className="selected_text">
                  {`is feeling ${getFeelingLabel(selectedFeeling).toLowerCase()}`}
                </span>
                <button 
                  className="cancel_feeling_btn"
                  onClick={() => setSelectedFeeling(null)}
                  title="Remove feeling"
                >
                  ×
                </button>
              </div>
            )}

            {selectedActivity && (
              <div className="selected_item_display">
                <span className="selected_emoji notranslate" translate="no">
                  {getActivityEmoji(selectedActivity)}
                </span>
                <span className="selected_text">
                  {`is ${getActivityLabel(selectedActivity).toLowerCase()}`}
                </span>
                <button 
                  className="cancel_activity_btn"
                  onClick={() => setSelectedActivity(null)}
                  title="Remove activity"
                >
                  ×
                </button>
              </div>
            )}

          </div>

        )}
        {/* Display selected friends */}

        {selectedFriends.length > 0 && (

          <div className="selected_friends">

            <div className="selected_friends_header">

              <span>Tagged Friends ({selectedFriends.length})</span>

            </div>

            <div className="selected_friends_list">

              {selectedFriends.map((friend) => (

                <div key={friend._id} className="selected_friend_item">

                  <img src={friend.picture} alt="" className="friend_picture" />

                  <span className="friend_name">

                    {friend.name || `${friend.first_name || ""} ${friend.last_name || ""}`.trim()}

                  </span>

                </div>

              ))}

            </div>

          </div>

        )}





        {selectedLocation && (
          <div className="selected_location_display">
            <div className="selected_location_header">
              <span>Location</span>
            </div>
            <div className="selected_location_item">
              <div className="location_icon">📍</div>
              <div className="location_info">
                <span className="location_name">
                  {selectedLocation.name || "Selected location"}
                </span>
                <span className="location_address">
                  {selectedLocation.address}
                </span>
              </div>
              <button
                type="button"
                className="cancel_feeling_btn"
                onClick={() => setSelectedLocation(null)}
                title="Remove location"
              >
                ×
              </button>
            </div>
          </div>
        )}

        </div>

        <div className="postBox_sticky_footer">
          <button
            className="post_submit"
            onClick={() => {
              postSubmit();
            }}
            disabled={loading}
          >
            {loading ? (
              <PulseLoader color="#fff" size={5} />
            ) : (
              <>
                <Send />
                <span>Publish</span>
              </>
            )}
          </button>
        </div>

        
        
        {/* Feeling/Activity Selector Modal */}

        {showFeelingActivitySelector && (

          <FeelingActivitySelector

            selectedFeeling={selectedFeeling}

            selectedActivity={selectedActivity}

            onFeelingSelect={setSelectedFeeling}

            onActivitySelect={setSelectedActivity}

            onClose={() => setShowFeelingActivitySelector(false)}

            onSubmit={() => setShowFeelingActivitySelector(false)}

            submitLabel="Send"

          />

        )}



        {/* Friends List Modal */}

        {showFriendsListModal && (

          <FriendsListModal

            onClose={() => setShowFriendsListModal(false)}

            onSelectFriends={handleFriendsSelection}

            selectedFriends={selectedFriends.map(friend => friend._id)}

          />

        )}



        {/* Location Picker Modal */}

        {showLocationPickerModal && (

          <LocationPickerModal

            onClose={() => setShowLocationPickerModal(false)}

            onSelectLocation={handleLocationSelection}

            selectedLocation={selectedLocation}

          />

        )}

      </div>

    </div>

  );

}



